import React from "react";
import { Modal } from "react-bootstrap";
import "react-quill/dist/quill.snow.css";

const Terms = ({ showTerms, handleClose, text }) => (
  <Modal show={showTerms} onHide={handleClose} size="lg" style={{ 
    // minWidth:"200%",
    //width:"200%"
    }}>
    <Modal.Body style={{display:"flex"} }>
   
     
      <embed 
      src="https://colcx-prd-btgderd3bfaybka4.a02.azurefd.net/apiuserbackend/files/register/TÉRMINOS Y CONDICIONES DE USO COLCX Registry V1.0.pdf" 
      type="application/pdf" 
      width="200%" height="700px" 
      />
  
    </Modal.Body>
  </Modal>
);

export default Terms;
